export default "__VITE_ASSET__da3ebd44__"